export const getSelectedValue = (statusId, optionsArr) => {
    return optionsArr.find(data => data.value === statusId);
}

export const getSelectedLabel = (statusId, optionsArr) => {
    const selectedData = optionsArr.find(data => data.value === statusId);
    return selectedData?.label || '-'
}